import { Observable, filter, take } from 'rxjs';
import { UserAuthentified } from './user-authentified.interface';

/**
 * Instantané one-shot d'un flux d'authentification : premier utilisateur
 * non nul, puis complétion.
 *
 * C'est le SEUL endroit du dépôt où un take(1) est appliqué à un flux d'auth.
 * Écrit une fois, testé une fois. Les call-sites doivent passer par
 * Dao.authOnce$(), Dao.command*() ou UserService.authOnce$() plutôt que
 * d'écrire leur propre take(1).
 */
export function authOnce(
  auth$: Observable<UserAuthentified>,
): Observable<UserAuthentified> {
  return auth$.pipe(
    filter(user => !!user),
    take(1),
  );
}
